import React from 'react';

import ModalBox from '../../shared/modal';
import { getCookie, setCookie } from '../../../../shared/js/cookie';
import './converter-popup.less';
import CloseIcon from '../../../apps/everad/assets/img/shared/icon-close-black.svg';

const isEverad = process.env.CPA_ENV === 'everad';

class Popup extends React.Component {
	constructor(props) {
		super(props);
		this.state = {};
		this.closePopup = this.closePopup.bind(this);
	}
	closePopup() {
		const nextPopupNumber = Number(getCookie('next_popup_number')) ? 0 : 1;

		setCookie('was_ro_popup_shown', 'true', 2 * 24); //2 * 24 hours
		setCookie('next_popup_number', nextPopupNumber, 365 * 10 * 24);
		this.setState({});//trigger rerender
	}
	render() {
		const {  props } = this;
		const  isRoPopupVisible = props.appConfig && props.appConfig.isRoPopupVisible;
		const isNotificationPopupVisible = !getCookie('was_ro_popup_shown') && isEverad && isRoPopupVisible;
		const nextPopupNumber = Number(getCookie('next_popup_number') || 0);
		const className = nextPopupNumber === 0
			? 'location-banner-popup-container'
			: 'secondary-location-banner-popup-container';
		return (
			<div>
				<ModalBox
					className={`modal-overlay__content no-close-cross ${className}`}
					body={ModalBody({
						language: props.intl.language, closePopup: this.closePopup, nextPopupNumber
					})}
					isOpen={isNotificationPopupVisible}
				/>
			</div>
		);
	}
}

const ModalBody = props => {
	return (
		<div className="converter-popup">
			<div
				className={
					props.nextPopupNumber === 0
						? `location-banner location-banner-${props.language}`
						: `secondary-location-banner secondary-location-banner-${props.language}`
				}
			>
				<img
					src={CloseIcon}
					className="close-image"
					onClick={props.closePopup}
				/>
			</div>
		</div>
	);
};

export default Popup;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/root/components/converter-popup.js